import React from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';

import MenuItem from '@/components/ui-bridge/core/MenuItem';
import PropTypes from 'prop-types';

import classes from '@/inspectionAttach/InspectorsFilter/style.module.scss';

const Option = ({ innerRef, isDisabled, isFocused, isSelected, innerProps, children }) => (
  <MenuItem
    buttonRef={innerRef}
    selected={isFocused}
    component="div"
    style={{
      fontWeight: isSelected ? 500 : 400,
    }}
    disabled={isDisabled}
    {...innerProps}
  >
    {children}
  </MenuItem>
);

const LoadingMessage = ({ getStyles, ...props }) => (
  <div {...props} style={getStyles('loadingMessage', props)}>
    <FormattedMessage id="loading" />
  </div>
);

const components = {
  Option,
  LoadingMessage,
};

const InspectorsFilterComponent = ({
  suggestions,
  isBusy,
  searchPlaceholder,
  handleChange,
  selectClassNamePrefix,
}) => (
  <div className={classes.Search}>
    <Select
      options={suggestions.map(suggestion => ({
        value: suggestion.public_id,
        label: suggestion.name,
        disabled: suggestion.status && suggestion.status !== 'OK',
      }))}
      isOptionDisabled={option => option.disabled}
      components={components}
      name="inspector"
      onChange={handleChange}
      placeholder={searchPlaceholder}
      isLoading={isBusy}
      backspaceRemovesValue={false}
      autoFocus
      classNamePrefix={selectClassNamePrefix}
      styles={{
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          background: 'transparent !important',
          border: 'none !important',
          boxShadow: 'none !important',
          '& input': {
            height: '100% !important',
            background: 'transparent !important',
            border: 'none !important',
            boxShadow: 'none !important',
            padding: '0 !important',
            margin: '0 !important',
          },
        }),
      }}
    />
  </div>
);

InspectorsFilterComponent.propTypes = {
  suggestions: PropTypes.array.isRequired,
  isBusy: PropTypes.bool.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  selectClassNamePrefix: PropTypes.string,
};

InspectorsFilterComponent.defaultProps = {
  selectClassNamePrefix: undefined,
};

export default InspectorsFilterComponent;
